import React from 'react';
import {
  View,
} from 'react-native';

import * as hf from './_hf';
import * as ht from './_ht';
import * as cr from './_cr';

import * as ica from 'src/ica';

import { useAny } from './_csLcl';

import { default as Swiper } from 'react-native-web-swiper';

export const N = React.memo((pDz: {
  abtType?: ht.s,
  boxStlz?: ht.dz,
  cz?: {
    nIdx?: ht.n,
    bVcl?: ht.b,
    bCrl?: ht.b, // Dots and control buttons visible and enabled
    nPrd?: ht.n, // period
    srgz?: ht.dz,
    onChg?: ( _nIdx: ht.n) => null,
  }
//  children: React.FC,
  oClds: ht.ls,
}) => {

  const _rThis = React.useRef<Swiper>(null);

  React.useEffect(() => {
    if (pDz.cz?.nIdx && pDz.cz?.nIdx >= 0) {
      _rThis.current?.goTo(pDz.cz.nIdx);
    }
  }, [
    pDz.cz?.nIdx,
  ])

  const _snKey = useAny(0); // to re-render on pDz.oClds change

  React.useEffect(() => {
    const _nKey = hf.getRdm(999999999);
    _snKey.set(_nKey);
  }, [
    pDz.oClds,
  ]);

  const _abtType = pDz.abtType ?? 'nmlz';
  const _abtz = ica.sprAbtz[_abtType] ? ica.sprAbtz[_abtType]() : {};

  //hf.l('SprC 53: ' + hf.s(pDz.cz))
  return (
    cr.c(View, {
      key: 'Spr.root',
      style: {
        ... _abtz.boxStlz,
        ... pDz.boxStlz,
      },
    },
      cr.c(Swiper, {
        key: _snKey.crt,
        ref: _rThis,
        vertical: pDz.cz?.bVcl ?? false,
        controlsEnabled: pDz.cz?.bCrl ?? false,
        loop: true,
        timeout: pDz.cz?.nPrd ?? 0,
        springConfig: pDz.cz?.srgz ?? { tension: 1 },
        minDistanceForAction: 0.20,
        controlsProps: {
          prevTitle: null,
          nextTitle: null,
          DotComponent: () => null
        },
        onIndexChanged: ( _nIdx: ht.n ) => {
          if (pDz.cz?.onChg) pDz.cz?.onChg(_nIdx);
        },
      }, 
        pDz.oClds,
      )
    )
  )
});
